import React from 'react'
import './admin-workflows.css'
import CardModal from '../CardModal/CardModal'
import TaskCard from '../TaskCard/TaskCard'
import StudentOnboardingTaskCard from './StudentOnboardingTaskCard/StudentOnboardingTaskCard'
import {PageCover} from '../PageCover/PageCover'
import {ErrorPopup} from '../ErrorPopup/ErrorPopup'
import Axios from 'axios'
import NewLoadingScreen from '../NewLoadingScreen/NewLoadingScreen'
import { baseUrl } from '../assets/Animations'
import loadingping from '../img/loadingpin.svg'
import axios from 'axios'
import { createStudentWorkflowFunction } from './WorkflowModels'

const myToken = localStorage.getItem('token')
const myHeader = {
    headers: { Authorization: `Bearer ${myToken}` }
}

const StudentWorkflows = (props) => {
        const [workflows, setWorkflows] = React.useState([])
        const [openModal, setOpenModal] = React.useState(false)
        const [backgroundCover, setBackgroundCover] = React.useState(false)
        const [error, setError] = React.useState(false)
        const [loading, setLoading] = React.useState(false)
        const [gettingWorkflows, setGettingWorkflows] = React.useState(false)
        const [columns, setColumns] = React.useState(true)
        const [instruments, setInstruments] = React.useState([])
        const listOfSchools = ['mma', 'lsma', 'tma', 'mor', 'psma']
        const [sortedByInstrument, setSortedByInstrument] = React.useState({'mma': {}, 'lsma': {}, 'tma': {}, 'mor': {}, 'psma': {}})
        const [generalTotal, setGeneralTotal] = React.useState({'mma': 0, 'lsma': 0, 'tma': 0, 'mor': 0, 'psma': 0})

    React.useEffect(() => {
        getTodos()
        getInstruments()
    }, [])

    React.useEffect(() => {
        sortWorkflows()
    }, [workflows])

    const toggleBackgroundCover = () => {
        setBackgroundCover(prev => !prev)
    }

    const sortWorkflows = () => {
        let myObj = {'mma': {}, 'lsma': {}, 'tma': {}, 'mor': {}, 'psma': {}}
        let myTotal = {'mma': 0, 'lsma': 0, 'tma': 0, 'mor': 0, 'psma': 0}
        for(let i = 0; i < workflows.length; i++) {
            if(workflows[i].instrumentList) {
                for(let j = 0; j < workflows[i].instrumentList.length; j++) {
                    myTotal[workflows[i].whichSchool] = myTotal[workflows[i].whichSchool] + 1
                    if(myObj[workflows[i].whichSchool][workflows[i].instrumentList[j].name]) {
                        myObj[workflows[i].whichSchool][workflows[i].instrumentList[j].name] = myObj[workflows[i].whichSchool][workflows[i].instrumentList[j].name] + 1
                    } else {
                        myObj[workflows[i].whichSchool][workflows[i].instrumentList[j].name] = 1
                    }
                }
            }
        }
        setSortedByInstrument({...myObj})
        setGeneralTotal({...myTotal})
    }

    const getTodos = async () => {
        setGettingWorkflows(true)
        Axios.get(`${baseUrl}/onboarding`, myHeader)
        .then(response => {
                setWorkflows(response.data)
                setLoading(false)
                setGettingWorkflows(false)
        })
        .catch(e => {
            setError({message: e.response.data, status: e.response.status})
        })
    }

    const getInstruments = () => {
        Axios.get(`${baseUrl}/inst`)
        .then((res) => setInstruments(res.data))
        .catch((err) => console.log(err))
    }

    const sendAnUpdateToMongo = async (todo) => {
        Axios.put(`${baseUrl}/onboarding/${todo.todoId}`, {
            todoId: todo.todoId,
            todoName: todo.todoName,
            todoDescription: todo.todoDescription,
            instrumentList: todo.instrumentList ? todo.instrumentList : [],
            teacherList: todo.teacherList ? todo.teacherList : [],
            todoDueDate: todo.todoDueDate,
            todoAlarm: todo.todoAlarm,
            todoOwner: todo.todoOwner,
            whichList: todo.whichList,
            whichSchool: todo.whichSchool,
            todoSubtasks: todo.todoSubtasks
        }, myHeader)
        .then(response => {
            setOpenModal(false)
            getTodos()
        })
        .catch(e => {
            console.log('YIKES ' + e)
            console.log(e)
            //XWINSTONX
            //flagAnError()
            setError({message: e.response.data, status: e.response.status})
        })
    }

    const openTheModal = (todo) => {
        setOpenModal(todo)
        setTimeout(() => {
            cardAnimation()
            props.getNotesAboutModal(todo.todoId, 'onboardingId', todo.todoName)
        }, 0)
    }

    const cardAnimation = () => {
            setTimeout(() => {
                document.getElementById('card-modal-content').style.marginRight = "-600px"
            }, 0)
            setTimeout(() => {
                document.getElementById('card-modal-content').style.marginRight = "400px"
                document.getElementById('card-modal').style.backgroundColor = "rgba(0, 0, 0, 0.2)"
            }, 10);
    }

    const closeModal = () => {
        let todoToUpdate = openModal
        document.getElementById('card-modal-content').style.marginRight = "-700px"
        document.getElementById('card-modal').style.backgroundColor = "rgba(0, 0, 0, 0)"
        props.setShowNotes(false)
        if(todoToUpdate.todoSubtasks.length === 0) {
            deleteTask(todoToUpdate)
        } else {
            setTimeout(() => {
                sendAnUpdateToMongo(todoToUpdate)
            }, 250);
        }
    }
    const changeTitle = (newTitle) => {
        setOpenModal({...openModal, todoName: newTitle}) 
    }
    const changeTheSchool = (school) => {
        setOpenModal({...openModal, whichSchool: school}) 
    }
    const changeDesc = (newDesc) => {
        setOpenModal({...openModal, todoDescription: newDesc})
    }
    const changeSubtaskName = (theValue, theId) => {
        let todo = openModal
        for(let i = 0; i < todo.todoSubtasks.length; i++) {
            if(theId === todo.todoSubtasks[i].subtaskId) {
                todo.todoSubtasks[i].subtaskName = theValue
            }
        }
        setOpenModal({...todo})
    }
    const changeSubtaskDueDate = (theValue, theId) => {
        //NEVER CHECKED THIS FUNCTION
        let todo = openModal
        for(let i = 0; i < todo.todoSubtasks.length; i++) {
            if(theId === todo.todoSubtasks[i].subtaskId) {
                todo.todoSubtasks[i].subtaskDueDate = theValue
            }
        }
        setOpenModal({...todo})
    }
    const changeSubSubName = (theValue, theSubSubId, theSubId, theTodo, whichList) => {
        let todo = openModal
        for(let i = 0; i < todo.todoSubtasks.length; i++) {
            if(theSubId === todo.todoSubtasks[i].subtaskId) {
                let subToEdit = todo.todoSubtasks[i]
                for(let i = 0; i < subToEdit.subtaskSubtasks.length; i++) {
                    if(theSubSubId === subToEdit.subtaskSubtasks[i].subtask2xId) {
                        subToEdit.subtaskSubtasks[i].subtask2xName = theValue
                    }
                }
            }
        }
        setOpenModal({...todo})
    }
    const deleteTask = async (todo) => {
        //DELETING ALL RELATED NOTES
        for(let i = 0; i < props.sideBarNotes.length; i++) {
            if(props.sideBarNotes[i].applicationId === '' && props.sideBarNotes[i].invoiceId === '' && props.sideBarNotes[i].familyId === '' && props.sideBarNotes[i].tasksId === '' && props.sideBarNotes[i].teacherId === '' && props.sideBarNotes[i].timesheetId === '' && props.sideBarNotes[i].workflowId === '' && props.sideBarNotes[i].miscId1 === '' && props.sideBarNotes[i].miscId2 === '' && props.sideBarNotes[i].miscId3 === '' && props.sideBarNotes[i].miscId4 === '' && props.sideBarNotes[i].miscId5 === '' && props.sideBarNotes[i].miscId6 === '' && props.sideBarNotes[i].miscId7 === '' && props.sideBarNotes[i].miscId8 === '' && props.sideBarNotes[i].miscId9 === '' && props.sideBarNotes[i].miscId10 === '') {
                await axios.delete(`${baseUrl}/notes/${props.sideBarNotes[i].id}`)
                .then((res) => {
                    //console.log(res)
                })
                .catch((err) => {
                    console.log(err)
                })
            }
        }
        //DELETING THE TODO
        setLoading("Deleting Workflow")
        Axios.delete(`${baseUrl}/onboarding/${todo.todoId}`, myHeader)
        .then((response) => {
            setOpenModal(false)
            props.setShowNotes(false)
            getTodos() 
        })
        .catch((err) => {
            console.log(err)
            setLoading(false)
        })
    }
    const deleteSubtask = (subtaskId) => {
        let todo = openModal
            for(let i = 0; i < todo.todoSubtasks.length; i++) {
                if(todo.todoSubtasks[i].subtaskId === subtaskId) {
                    todo.todoSubtasks.splice(i, 1)
                }
        };
        setOpenModal({...todo})
    }
    const delete2xSub = (sub2xId, subtaskId) => {
        let todo = openModal
        for(let i = 0; i < todo.todoSubtasks.length; i++) {
            if(todo.todoSubtasks[i].subtaskId === subtaskId) {
                let theSubsub = todo.todoSubtasks[i].subtaskSubtasks
                for( let i = 0; i < theSubsub.length; i++) {
                    if(theSubsub[i].subtask2xId === sub2xId) {
                        theSubsub.splice(i, 1)
                    }
                }
                todo.todoSubtasks[i].subtaskSubtasks = theSubsub
            }
        }
        setOpenModal({...todo})
    };
    const createWorkflow = () => {
        setLoading('Creating Workflow')

        let studentWorkflow = createStudentWorkflowFunction(props.userData.Name)

        Axios.post(`${baseUrl}/onboarding`, {
            todoId: studentWorkflow.todoId,
            todoName: studentWorkflow.todoName,
            todoDescription: studentWorkflow.todoDescription,
            instrumentList: studentWorkflow.instrumentList ? studentWorkflow.instrumentList : [],
            teacherList: studentWorkflow.teacherList ? studentWorkflow.teacherList : [],
            todoDueDate: studentWorkflow.todoDueDate,
            todoAlarm: studentWorkflow.todoAlarm,
            todoOwner: studentWorkflow.todoOwner,
            whichList: studentWorkflow.whichList,
            whichSchool: studentWorkflow.whichSchool,
            todoSubtasks: studentWorkflow.todoSubtasks
        }, myHeader)
        .then((response) => {
            setWorkflows([...workflows, response.data])
            setLoading(false)
            openTheModal(response.data)
        })
        .catch((err) => {
            console.log(err)
            setLoading(false)
        })
    }
    const addNewSubtask = (newSubtask) => {
        let todo = openModal
        todo.todoSubtasks.push(newSubtask)
        setOpenModal({...todo})
    }
    const addNewSubSub = (subId) => {
        let newSubSub = {
            subtask2xId: Math.random().toString(16).slice(2),
            subtask2xName: 'New mini todo...'
        }
        let todo = openModal
        for(let i = 0; i < todo.todoSubtasks.length; i++) {
            if(todo.todoSubtasks[i].subtaskId === subId) {
                todo.todoSubtasks[i].subtaskSubtasks.push(newSubSub)
            }
        }
        setOpenModal({...todo})
    }
    const changeOwner = (theValue) => {
        setOpenModal({...openModal, todoOwner: theValue})
    }
    const changeDueDate = (theValue) => {
        setOpenModal({...openModal, todoDueDate: theValue})
    }
    const closeErrorModal = () => {
        setError(false)
    }
    const editInstruments = (insts) => {
        setOpenModal({...openModal, instrumentList: insts})
    }
    // const flagAnError = () => {
    //     setError(true)
    // }

    return (
        <div className="admin-task-page">
            <PageCover pagecover={backgroundCover} toggleBackgroundCover={toggleBackgroundCover}/>
            <div className="student-onboarding__main-area">
                <div className="new-workflow-drop-down">
                    <div className="create-new-workflow-btn" onClick={() => createWorkflow()}>+ Onboard Student</div>
                </div>
                <div className="area-title">Student Onboarding</div>
                <div className="student-onboarding__toggle-switch" onClick={() => setColumns(!columns)}>
                        {columns && <svg className="switch-svg" viewBox="0 0 511.999 511.999">
                            <g>
                            	<g>
                            		<path fill="rgba(230, 230, 230, 0.7)" d="M376.499,120.5h-241C60.784,120.5,0,181.286,0,256s60.784,135.5,135.499,135.5h241c74.715,0,135.5-60.785,135.5-135.5
                            			S451.214,120.5,376.499,120.5z M135.499,361.501C77.326,361.501,30,314.173,30,256c0-58.173,47.326-105.5,105.499-105.5
                            			c58.173,0,105.5,47.327,105.5,105.5C240.999,314.173,193.672,361.501,135.499,361.501z"/>
                            	</g>
                            </g>
                        </svg>}
                        {!columns && <svg className="switch-svg" viewBox="0 0 512 512">
                            <g>
                            	<g>
                            		<path fill="rgba(245, 245, 245, 1)" d="M376.5,120.5h-241C60.785,120.5,0,181.285,0,256s60.785,135.5,135.5,135.5h241c74.715,0,135.5-60.785,135.5-135.5
                            			S451.215,120.5,376.5,120.5z M376.5,361.5C318.327,361.5,271,314.174,271,256c0-58.172,47.327-105.5,105.5-105.5
                            			c58.173,0,105.5,47.328,105.5,105.5C482,314.174,434.673,361.5,376.5,361.5z"/>
                            	</g>
                            </g>
                        </svg>} 
                        <p className="student-onboarding__toggle-switch__label">Switch View</p>  
                    </div>
                {columns ?
                    <div>
                        {listOfSchools.map((schoolAbb) => (
                            <div className='student-onboarding__column'>
                                <div className='student-onboarding__column__title'>{schoolAbb.toUpperCase()} {generalTotal[schoolAbb] > 0 && <span className="student-onboarding__red-circle">{generalTotal[schoolAbb]}</span>}</div>
                                <div className='student-onboarding__instrument-totals__wrapper'>
                                    {Object.keys(sortedByInstrument[schoolAbb]).map((key, index) => (
                                        <div key={index} className='student-onboarding__instrument-totals__each-one'><p className='student-onboarding__instrument-totals__inst'>{key}:</p> <p className='student-onboarding__instrument-totals__total'>{sortedByInstrument[schoolAbb][key]}</p></div>
                                    ))}
                                </div>
                                {schoolAbb === 'psma' ?
                                    <div className='student-onboarding__scroll-column'>
                                        {workflows.map(workflow => 
                                            workflow.whichList === 'student' && (workflow.whichSchool === schoolAbb || workflow.whichSchool === 'all') ?
                                            <StudentOnboardingTaskCard 
                                                whichList = 'workflows'
                                                key={workflow.todoId} deleteTask={deleteTask} 
                                                openModal={openTheModal} todo={workflow} 
                                                changeDueDate={changeDueDate}
                                                toggleBackgroundCover={toggleBackgroundCover}
                                            /> : null)
                                        }
                                    </div> 
                                :                                
                                    <div className='student-onboarding__scroll-column'>
                                        {workflows.map(workflow => 
                                            workflow.whichList === 'student' && workflow.whichSchool === schoolAbb ?
                                            <StudentOnboardingTaskCard 
                                                whichList = 'workflows'
                                                key={workflow.todoId} deleteTask={deleteTask} 
                                                openModal={openTheModal} todo={workflow} 
                                                changeDueDate={changeDueDate}
                                                toggleBackgroundCover={toggleBackgroundCover}
                                            /> : null)
                                        }
                                    </div> 
                                }      
                            </div>
                        ))}
                    </div> 
                    :
                    <div className="tasks-area-scroll just-scooch-it student-onboarding__no-columns">
                        {gettingWorkflows && <img className="loading-ping" src={loadingping} />}
                        {workflows.map(workflow => 
                            workflow.whichList === 'student' ?
                            <TaskCard 
                                whichList = 'workflows'
                                key={workflow.todoId} deleteTask={deleteTask} 
                                openModal={openTheModal} todo={workflow} 
                                changeDueDate={changeDueDate}
                                toggleBackgroundCover={toggleBackgroundCover}
                            /> : null)
                        }
                    </div>
                }
            </div>
            {openModal && 
                <CardModal key={openModal.todoId}
                    whichList = {'student'}
                    deleteTask = {deleteTask}
                    changeSubtaskName={changeSubtaskName} 
                    addNewSubtask={addNewSubtask} 
                    //createTask={createTask} 
                    changeDesc={changeDesc} 
                    changeTitle={changeTitle} 
                    changeTheSchool={changeTheSchool}
                    todo={openModal} 
                    closeModal={closeModal} 
                    openModal={openModal}
                    deleteSubtask={deleteSubtask}
                    delete2xSub={delete2xSub}
                    addNewSubSub={addNewSubSub}
                    changeSubSubName={changeSubSubName}
                    changeOwner={changeOwner}
                    changeDueDate={changeDueDate}
                    changeSubtaskDueDate={changeSubtaskDueDate}
                    toggleBackgroundCover={toggleBackgroundCover}
                    setError={setError}
                    instList={instruments}
                    editInstruments={editInstruments}
                />
            }
            {error && <ErrorPopup error={error} setError={closeErrorModal}/>}
            {loading && <NewLoadingScreen logo="favicon.png" message={loading} />}
        </div>
    )
}


export default StudentWorkflows